<template>
  <v-card :disabled="loading">
    <v-row class="ma-0">
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-col
        cols="4"
        class="info-item-details text-center"
      >
        <div class="info-item-details-value">
          {{ getTimeSlot(session.appointmentStartDate,session.appointmentEndDate) }}
        </div>
        <div class="info-item-details-value">
          {{ isAm(session.appointmentStartDate)? local.calendar.am: local.calendar.pm }}
        </div>
        <div
          v-if="session.appointmentDurationInMinutes"
          class="info-item-details-value"
        >
          <v-icon
            small
            class="icon ma-0"
            color="#A6B8BB"
          >
            mdi-clock-outline
          </v-icon>
          {{ session.appointmentDurationInMinutes }} {{ local.calendar.min }}
        </div>
      </v-col>
      <v-col cols="6">
        <div class="info-item-details-value">
          {{ session.sessionType }}
        </div>
        <div>
          <span>{{ local.calendar.caseCode }} {{ session.caseCode }}</span>
        </div>
        <div>
          {{ session.court }}
        </div>
        <div class="session-type mt-1">
          {{ local.home.upcomingSessions.sessionType }}
        </div>
        <template v-if="session.isVideoConference">
          <div>
            <template>
              <span>
                {{ local.home.upcomingSessions.remoteSession }}
              </span>
            </template>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="var(--app-primary-color)"
                  class="copy-icon ml-1"
                  v-bind="attrs"
                  left
                  v-on="on"
                  @click="copyURL"
                >
                  mdi-content-copy
                </v-icon>
              </template>
              <span> {{ local.home.upcomingSessions.copyLink }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-else>
          <div>
            {{ local.home.upcomingSessions.attendanceSession }}
            <v-icon
              color="var(--app-primary-color)"
              class="copy-icon ml-1"
              left
            >
              mdi-map-marker
            </v-icon>
            <span> {{ local.home.upcomingSessions.courtLocation }} </span>
          </div>
        </template>
      </v-col>
      <v-col
        v-if="false && session.sessionStatusId == 1"
        cols="2"
        class="text-left pt-2 pl-2 pa-0"
      >
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-icon
              small
              v-on="on"
            >
              mdi-dots-vertical
            </v-icon>
          </template>
          <v-list>
            <v-list-item v-if="false && session.sessionStatusId == 1">
              <v-list-item-title>
                <router-link :to="`/lawsuit-requests/${session.objectKey}`">
                  <naj-button
                    text
                    type="button"
                    size="small"
                  >
                    {{ local.home.upcomingSessions.changeSessionRequest }}
                  </naj-button>
                </router-link>
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="false && session.sessionStatusId == 3">
              <v-list-item-title>
                <router-link :to="`/lawsuit-requests/${session.objectKey}`">
                  <naj-button
                    text
                    type="button"
                    size="small"
                  >
                    {{ local.home.upcomingSessions.requestApproveAttendanceRequest }}
                  </naj-button>
                </router-link>
              </v-list-item-title>
            </v-list-item>

            <v-list-item v-if="session.sessionTypeId == sessionTypes.remoteArgument || session.sessionTypeId == sessionTypes.caseManagementELitigation">
              <v-list-item-title>
                <router-link :to="`/written-pleading?caseObjectKey=${caseObjectKey}&courtId=${courtId}&sessionTypeId=${session.sessionTypeId}&sessionObjectKey=${session.objectKey}&isPega=${isPega}`">
                  <naj-button
                    text
                    type="button"
                    size="small"
                  >
                    {{ local.home.upcomingSessions.writtenPleading }}
                  </naj-button>
                </router-link>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');
import { toHijriDate, getTimePart, getTimeSlot, getDateObj, isAm } from '@/helpers/utils';
import { sessionTypes } from '@/helpers/enum';

export default {
  name: 'CalendarSessionCard',
  components: {},
  props: {
    session: {
      type: Object,
      required: true,
    },
    caseObjectKey: {
      type: String,
      required: true,
    },
    isPega: {
      type: [String, Boolean],
      required: true,
    },
    courtId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      sessionTypes,
      loading: false,
    };
  },
  methods: {
    ...mapCasesActions([
      'getVideoConference',
    ]),
    isAm,
    getTimeSlot,
    getDateObj,
    toHijriDate,
    getTimePart,
    openVideoConferenceUrl() {
      this.loading = true;
      this.getVideoConference(this.session.objectKey)
        .then((res) => {
          window.open(res.data, '_blank');
        })
        .finally(() => (this.loading = false));
    },
    async copyURL() {
      if (this.session.videoConferenceUrl) {
        await navigator.clipboard.writeText(this.session.videoConferenceUrl);
        this.toaster.success(this.local.home.upcomingSessions.copied);
      }
    },
  },
};

</script>

<style scoped>
.copy-icon {
  font-size: 20px;
}
    .videoConferenceUrl {
        color: var(--app-primary-color);
        cursor: pointer;
    }

.session-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-text {
  font-weight: 700;
  font-size: 18px;
  color: var(--app-dark-primary-color);
}

    .text-c-green {
        color: var(--app-primary-color);
    }

.text-c-dark {
  color: var(--app-dark-primary-color);
}

.text-c-lite {
  color: #a6b8bb;
}

.info-item-details {
  background: #faf9f4;
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1;
  color: var(--app-dark-primary-color);
}

.session-type {
  color: #a6b8bb;
}

.info-item-details-value {
  font-weight: bold;
  font-size: 14px;
  text-shadow: 0px 3px 6px #daeae7;
}
</style>
